import { ca } from '@cian/analytics';
import { IConsultationRequestData } from '@cian/frontend-builders-callback-widget';

import { useCallback, useMemo } from 'react';
import { ECallbackWidgetPlacement } from '../../../types/callbackWidget';

enum EAnalyticsPlacement {
  FloatingBlock = 'floating_block',
  TourBlock = '3d',
  Gallery = 'gallery',
  MoreBlock = 'more_block',
}

export const MAP_PLACEMENT_TO_ANALYTICS: Record<ECallbackWidgetPlacement, EAnalyticsPlacement> = {
  [ECallbackWidgetPlacement.Sidebar]: EAnalyticsPlacement.FloatingBlock,
  [ECallbackWidgetPlacement.Gallery]: EAnalyticsPlacement.Gallery,
  [ECallbackWidgetPlacement.Tour]: EAnalyticsPlacement.TourBlock,
  [ECallbackWidgetPlacement.Author]: EAnalyticsPlacement.MoreBlock,
};

export const useCallbackAnalytics = (placement: ECallbackWidgetPlacement) => {
  const analyticsPlacement = useMemo(() => MAP_PLACEMENT_TO_ANALYTICS[placement], [placement]);

  const trackCallbackModalOpen = useCallback(() => {
    trackCallbackWidgetActions({
      ea: `CallBack_popup_open_${analyticsPlacement}`,
    });
  }, [analyticsPlacement]);

  const trackCallbackApplicationSubmit = useCallback(
    (requestData: IConsultationRequestData) => {
      trackCallbackWidgetActions({
        ea: `CallBack_popup_send_${analyticsPlacement}`,
        extra: { socialnetwork: requestData.communicationType },
      });
    },
    [analyticsPlacement],
  );

  return useMemo(
    () => ({ trackCallbackModalOpen, trackCallbackApplicationSubmit }),
    [trackCallbackApplicationSubmit, trackCallbackModalOpen],
  );
};

interface ITrackingData {
  ea: string;
  extra?: {
    socialnetwork: IConsultationRequestData['communicationType'];
  };
}

function trackCallbackWidgetActions(data: ITrackingData) {
  ca('eventSite', {
    ec: 'CardCSP',
    useLastProducts: true,
    ...data,
  });
}
